import $ from 'jquery';
import Vue from 'vue';
import Select from './Select';
import SelectModal from './SelectModal';

const selects = $('select')
    .not('[name="tx_kunstdesign_news[category]"]')
    .not('[name="tx_kunstdesign_news[area]"]');

selects.hide(); // hide all the selects as we use vue to render nice looking solution

let UNIQUE_ID = 0;
selects.each(function () {
    const $select = $(this);
    const element = document.createElement('div');
    $select.after(element);

    const options      = [],
          initialValue = [],
          labels       = [],
          isMultiple   = $select.attr('multiple'),
          uniqueId     = UNIQUE_ID++,
          noClear      = $select.hasClass('no-clear');

    const label   = $(`label[for=${$select.attr('id')}]`).first();
    const labelId = label.length && `select-label-${uniqueId}` || '';
    label.attr('id', labelId);

    $select.find('option').each(function () {
        const $option = $(this);
        options.push($option.val());
        labels.push($option.text());
        if ($option.attr('selected')) {
            initialValue.push($option.val());
        }
    });

    if (initialValue.length === 0) {
        initialValue.push('');
    }

    const selectModalVm = new Vue({
        data: {
            open: false,
            value: initialValue,
        },
        render (h) {
            return h(SelectModal, {
                props: {
                    open: this.open,
                    options,
                    value: this.value,
                    isMultiple,
                    labels,
                    uniqueId,
                    labelId,
                },
                on: {
                    select: this.select,
                    open: this.onOpen,
                },
            });
        },
        methods: {
            select (value) {
                // Update the data for 2 way binding and propagate change to the select under.
                this.value = value;
                $select.val(this.isMultiple ? value : value[0]).change();
                this.$emit('select', value);
            },
            onOpen (value) {
                this.open = value;
            },
        },
    });

    // Make new vue instance for every select.
    const selectVm = new Vue({
        data() {
            return {
                value: initialValue,
            };
        },
        render (h) {
            return h(Select, {
                props: {
                    options,
                    value: this.value,
                    multiple: isMultiple,
                    labels,
                    open: selectModalVm.open,
                    uniqueId,
                    labelId,
                    label: label.text(),
                    noClear: noClear,
                },
                on: {
                    open: this.open,
                    select: this.select,
                },
            });
        },
        methods: {
            open (value) {
                Vue.set(selectModalVm, 'open', value);
            },
            select (value) {
                selectModalVm.select(value);
            },
        },
    });

    selectModalVm.$on('select', function (value) {
        Vue.set(selectVm, 'value', value);
    });

    selectVm.$mount(element);

    const selectModalDomElement = document.createElement('div');
    $(document.body).append(selectModalDomElement);
    selectModalVm.$mount(selectModalDomElement);
});
